import axios from "axios";
import { api } from "./client";

const BASE = process.env.REACT_APP_BACKEND_URL;

// --- Admin (authenticated) -------------------------------------------------
const adminShare = {
  list: (status = "all", search = "") =>
    api.get(`/share/links`, { params: { status, search: search || undefined } }),
  create: (payload) => api.post(`/share/links`, payload),
  patch: (id, payload) => api.patch(`/share/links/${id}`, payload),
  revoke: (id) => api.post(`/share/links/${id}/revoke`, {}),
  remove: (id) => api.delete(`/share/links/${id}`),
  bulkCleanup: (mode) => api.post(`/share/links/bulk-cleanup`, { mode }),
};

// --- Public (no auth, fresh axios so no Bearer token leaks) ----------------
const publicAxios = axios.create({ baseURL: `${BASE}/api/share/public` });

const publicShare = {
  meta: (token) => publicAxios.get(`/${token}`),
  verifyPin: (token, pin) => publicAxios.post(`/${token}/verify-pin`, { pin }),
  bumpView: (token) => publicAxios.post(`/${token}/view`, {}),
  report: (token, report, grant, params = {}) =>
    publicAxios.get(`/${token}/reports/${report}`, {
      params,
      headers: grant ? { "X-Access-Grant": grant } : undefined,
    }),
};

export { adminShare, publicShare };
export default adminShare;
